<template>
    <section class="navbar-box">
      <div class="container">
        <ul class="nav">
          <li class="nav__item">
            <button
              class="nav__link"
              @click="clickMenuItem({ name : 'tools.answer'})"
            >
              Assuntômetro
            </button>
          </li>

          <li  class="nav__item">
            <button
              class="nav__link"
              @click="clickMenuItem({ name : 'tools.instatags'})"
            >
              Instatags
            </button>
          </li>

          <li  class="nav__item"  v-if="hasUserSubscriptionAccess">
            <button
              class="nav__link"
              @click="clickMenuItem({ name : 'lives.premium'})"
            >
              Lives
            </button>
          </li>
        </ul>
      </div>
    </section>
  </template>
  
  <script>
    import { mapGetters } from 'vuex'
  
    export default {
      computed: {
        ...mapGetters('user', ['isLogged', 'user', 'hasUserSubscriptionAccess'])
      },
  
      methods: {
        clickMenuItem (route) {
            this.$router.push(route)
        }
      }
    }
  </script>
  
  <style scoped lang="scss">
    .nav {
      $p: &;
  
      display: flex;
      justify-content: space-between;
      margin: 0;
      padding: 0;
      flex-direction: column;
      border: 0;
  
      &__link {
        position: relative;
        display: flex;
        width: 100%;
        align-items: center;
        padding: 16px 8px;
        font-size: 0.89rem;
        border-top: 2px solid transparent;
        border-bottom: 2px solid transparent;
  
        // &:after {
        //   content: '';
        //   position: absolute;
        //   bottom: -2px;
        //   left: 50%;
        //   transform: translateX(-50%);
        //   width: 0%;
        //   height: 2px;
        //   background-color: transparent;
        //   transition: .5s all;
        // }
  
        div {
          margin-right: 5px;
          width: 27px;
          height: 27px;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 25%;
  
          ::v-deep svg {
            width: 16px;
            fill: #fff;
          }
        }
      }
  
      &__item &__link {
        color: var(--color);
        font-size: 18px;
        font-weight: 300;
        padding: 0.9375rem 0;
        border: 0;
        transition: .5s all;
  
        div {
          border: 1px solid transparent;
          transition: .5s all;
          background: var(--color);
  
          ::v-deep svg { fill: #fff; transition: .5s all }
        }
  
        // &:hover {
        //   transform: translateX(10px);
        //   &:after {
        //     width: 100%;
        //     background: var(--color);
        //   }
        // }
      }
  
      &__item {
        position: relative;
        // transition: .5s all;
  
        // &:hover {
        //   border-color: transparent;
        // }
      }
    }
  </style>